export default __webpack_public_path__ + "static/media/googleCloud.a99e48fa.png";